import {
  TYPESENSE_FALLBACK_HOST_1,
  TYPESENSE_FALLBACK_HOST_2,
  TYPESENSE_FALLBACK_HOST_3,
  TYPESENSE_FALLBACK_HOST_4,
  TYPESENSE_FALLBACK_HOST_5,
  TYPESENSE_HOST,
} from "@next-platform/client-common-core/infra/constants";

import {
  TYPESENSE_CACHE_SEARCH_RESULTS_SECONDS,
  TYPESENSE_CONNECTION_TIMEOUT_SECONDS,
  TYPESENSE_HEALTHCHECK_INTERVAL_SECONDS,
  TYPESENSE_NODE_PORT,
  TYPESENSE_NODE_PROTOCOL,
  TYPESENSE_NUM_RETRIES,
  TYPESENSE_RETRY_INTERVAL_SECONDS,
  TYPESENSE_SEARCH_CUTOFF_MS,
} from "@/constants";

interface ICreateSearchClientConfigProps {
  apiKey?: string;
  queryBy?: string;
  includeFields?: string;
  filterByOptions?: Record<string, { exactMatch: boolean }>;
}

export function createSearchClientConfig({
  apiKey,
  queryBy,
  includeFields,
  filterByOptions = { tags: { exactMatch: false } },
}: ICreateSearchClientConfigProps) {
  const protocol = TYPESENSE_NODE_PROTOCOL;
  const port = TYPESENSE_NODE_PORT;
  const fallbackHosts = [
    TYPESENSE_FALLBACK_HOST_1,
    TYPESENSE_FALLBACK_HOST_2,
    TYPESENSE_FALLBACK_HOST_3,
    TYPESENSE_FALLBACK_HOST_4,
    TYPESENSE_FALLBACK_HOST_5,
  ];
  return {
    server: {
      apiKey: apiKey as string,
      useServerSideSearchCache: true,
      nearestNode: {
        host: TYPESENSE_HOST as string,
        port,
        protocol,
      },
      nodes: fallbackHosts.map((host) => ({
        host: host as string,
        port,
        protocol,
      })),
      cacheSearchResultsForSeconds: TYPESENSE_CACHE_SEARCH_RESULTS_SECONDS,
      connectionTimeoutSeconds: TYPESENSE_CONNECTION_TIMEOUT_SECONDS,
      healthcheckIntervalSeconds: TYPESENSE_HEALTHCHECK_INTERVAL_SECONDS,
      numRetries: TYPESENSE_NUM_RETRIES,
      retryIntervalSeconds: TYPESENSE_RETRY_INTERVAL_SECONDS,
    },
    filterByOptions,
    flipNegativeRefinementOperator: true,
    additionalSearchParameters: {
      query_by: queryBy,
      include_fields: includeFields,
      highlight_fields: "none",
      enable_highlight_v1: false,
      search_cutoff_ms: TYPESENSE_SEARCH_CUTOFF_MS,
      facet_sample_percent: 20,
      facet_sample_threshold: 10000,
    },
  };
}
